import React from "react";
import { Button, Col, FormGroup, Label } from "reactstrap";

export type ConfirmUploadImgProps = {
  img?: { filename?: string; secure_url?: string | string[] };
  path?: string;
  ConfirmUpload?: () => void;
};

const ConfirmUploadImg = ({
  img = {},
  path = "",
  ConfirmUpload = () => {},
}: ConfirmUploadImgProps) => {
  return (
    <FormGroup className="row justify-content-center">
      <Col className="col-auto">
        <Label
          className="form-control-label"
          htmlFor="confirm-upload"
          style={{ margin: "10px 0 0 0" }}
        >
          Are you sure to Upload{" "}
          <strong className="text-primary">{img?.filename}</strong> in Folder{" "}
          <strong className="text-primary">{path}</strong> ?
        </Label>
      </Col>

      <Col className="col-auto" style={{ maxWidth: "70px" }}>
        <Button
          id="confirm-upload"
          type="button"
          size="md"
          className="btn justify-content-center"
          onClick={ConfirmUpload}
          style={{ backgroundColor: "transparent" }}
        >
          Yes
        </Button>
      </Col>
    </FormGroup>
  );
};

export default ConfirmUploadImg;
